import { useState, useCallback } from 'react';

/**
 * useLeaderModals - Custom Hook zur zentralen Steuerung aller Modal-Zustände im Leader Tool.
 * Kapselt die Sichtbarkeit und spezifische Daten für Export, Konflikte, Ressourcen etc.
 * 
 * @returns {Object} Modal-States und Toggle-Funktionen
 */
export const useLeaderModals = () => {
    // --- Modal Visibility States ---
    const [exportOpen, setExportOpen] = useState(false);
    const [conflictOverviewOpen, setConflictOverviewOpen] = useState(false);
    const [absenceModalOpen, setAbsenceModalOpen] = useState(false);
    const [projectModalOpen, setProjectModalOpen] = useState(false);
    const [kolonnenManagementOpen, setKolonnenManagementOpen] = useState(false);
    const [vehicleModalOpen, setVehicleModalOpen] = useState(false);
    const [clientModalOpen, setClientModalOpen] = useState(false);
    const [workerModalOpen, setWorkerModalOpen] = useState(false);

    // --- UI Context Data ---
    const [editingKolonneId, setEditingKolonneId] = useState(null);
    const [absenceWorkerId, setAbsenceWorkerId] = useState(null);
    const [focusResource, setFocusResource] = useState(null);
    const [editingProjectId, setEditingProjectId] = useState(null);
    const [companyLoc, setCompanyLoc] = useState(null);
    const [categories, setCategories] = useState([]);
    const [sidebarMode, setSidebarMode] = useState('resources');
    
    // --- Conflict Persistence States ---
    const [conflictExpandedResources, setConflictExpandedResources] = useState(new Set());
    const [conflictCollapsedSections, setConflictCollapsedSections] = useState(new Set(['kolonnen', 'personen', 'fahrzeuge']));

    /**
     * Schließt die Konflikt-Zentrale und setzt den Fokus zurück.
     */
    const closeConflictOverview = useCallback(() => {
        setConflictOverviewOpen(false);
        setFocusResource(null);
    }, []);

    /**
     * Öffnet das Kolonnen-Management für eine spezifische Kolonne.
     */
    const openKolonnenManagement = useCallback((id = null) => {
        setEditingKolonneId(id);
        setKolonnenManagementOpen(true);
    }, []);

    return {
        // Visibility
        exportOpen, setExportOpen,
        conflictOverviewOpen, setConflictOverviewOpen,
        absenceModalOpen, setAbsenceModalOpen,
        projectModalOpen, setProjectModalOpen,
        kolonnenManagementOpen, setKolonnenManagementOpen,
        vehicleModalOpen, setVehicleModalOpen,
        clientModalOpen, setClientModalOpen,
        workerModalOpen, setWorkerModalOpen,

        // Data
        editingKolonneId, setEditingKolonneId,
        absenceWorkerId, setAbsenceWorkerId,
        focusResource, setFocusResource,
        editingProjectId, setEditingProjectId,
        companyLoc, setCompanyLoc,
        categories, setCategories,
        sidebarMode, setSidebarMode,
        conflictExpandedResources, setConflictExpandedResources,
        conflictCollapsedSections, setConflictCollapsedSections,

        // Handlers
        closeConflictOverview,
        openKolonnenManagement
    };
};
